import { jsx as _jsx } from "react/jsx-runtime";
import { MemberClients } from '@src/components/Admin/MemberClients';
import { PaymentRequestClaimsList } from '@src/components/Claims';
import { useAuth } from '@src/hooks/useAuth';
import { ClaimsTab } from '@src/hooks/usePaymentRequestClaims';
import { useParams } from 'react-router-dom';
export const ClaimsList = () => {
    const { tab = 'pending' } = useParams();
    const { isSuperuser, currentUser } = useAuth();
    const selectedTab = tab.toLowerCase();
    return (_jsx("div", { children: (tab === ClaimsTab.CONFIG && currentUser && isSuperuser && (
        // For now, claims processors belong to Guild, so we don't need to show this tab for other clients
        _jsx(MemberClients, { clientId: currentUser.clientId }))) || _jsx(PaymentRequestClaimsList, { showFilter: true, tab: selectedTab }) }));
};
